import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const fetchEvents = async (limit = 100) => {
  const res = await axios.get(`${API}/events`, { params: { limit } });
  return res.data;
};

/**
 * Kies veldwaarde voor huidige taal met NL-fallback.
 * Gebruik: pickField(ev, "title", "de") → ev.title_de || ev.title.
 */
export const pickField = (ev, field, lang) => {
  if (!ev) return "";
  if (lang === "nl" || !lang) return ev[field] || "";
  const localised = ev[`${field}_${lang}`];
  return localised && localised.trim() ? localised : ev[field] || "";
};

// Category label per lang. Backend stuurt lowercase key. Fallback = capitalised NL.
const CATEGORY_LABELS = {
  nl: {
    maritiem: "Maritiem",
    watersport: "Watersport",
    festival: "Festival",
    markt: "Markt",
    cultuur: "Cultuur",
    muziek: "Muziek",
    sport: "Sport",
    feest: "Feest",
  },
  de: {
    maritiem: "Maritim",
    watersport: "Wassersport",
    festival: "Festival",
    markt: "Markt",
    cultuur: "Kultur",
    muziek: "Musik",
    sport: "Sport",
    feest: "Fest",
  },
  en: {
    maritiem: "Maritime",
    watersport: "Watersports",
    festival: "Festival",
    markt: "Market",
    cultuur: "Culture",
    muziek: "Music",
    sport: "Sport",
    feest: "Festival",
  },
};

export const eventCategoryLabel = (category, lang = "nl") => {
  if (!category) return "";
  const key = String(category).toLowerCase();
  return (
    (CATEGORY_LABELS[lang] || CATEGORY_LABELS.nl)[key] ||
    key.charAt(0).toUpperCase() + key.slice(1)
  );
};

// Kleur/tekstkleur per lowercase category.
export const EVENT_CATEGORY_META = {
  maritiem: { color: "#173A5E", textColor: "#FFFFFF" },
  watersport: { color: "#2E9CD6", textColor: "#FFFFFF" },
  festival: { color: "#CE1B2A", textColor: "#FFFFFF" },
  markt: { color: "#F3C300", textColor: "#173A5E" },
  cultuur: { color: "#2E9CD6", textColor: "#FFFFFF" },
  muziek: { color: "#CE1B2A", textColor: "#FFFFFF" },
  sport: { color: "#22a56b", textColor: "#FFFFFF" },
  feest: { color: "#CE1B2A", textColor: "#FFFFFF" },
  default: { color: "#6BC0E8", textColor: "#173A5E" },
};

const LOCALES = { nl: "nl-NL", de: "de-DE", en: "en-GB" };

/** ISO-datum → geformatteerd voor huidige taal. Bij recurring valt terug op recurring_{lang}. */
export const formatEventDate = (ev, lang = "nl") => {
  if (!ev.date && ev.recurring) {
    const rec = pickField(ev, "recurring", lang) || ev.recurring;
    return capitalize(rec);
  }
  if (!ev.date) return "";
  const parseIso = (s) => {
    const [y, m, d] = s.split("-").map(Number);
    return new Date(Date.UTC(y, m - 1, d));
  };
  const locale = LOCALES[lang] || LOCALES.nl;
  const fmtDay = (d) =>
    d.toLocaleDateString(locale, {
      weekday: "short",
      day: "numeric",
      timeZone: "UTC",
    });
  const fmtFull = (d) =>
    d.toLocaleDateString(locale, {
      weekday: "short",
      day: "numeric",
      month: "short",
      year: "numeric",
      timeZone: "UTC",
    });
  const start = parseIso(ev.date);
  if (!ev.end_date || ev.end_date === ev.date) return fmtFull(start);
  const end = parseIso(ev.end_date);
  const sameMonth =
    start.getUTCMonth() === end.getUTCMonth() &&
    start.getUTCFullYear() === end.getUTCFullYear();
  if (sameMonth) {
    const monthName = end.toLocaleDateString(locale, {
      month: "short",
      timeZone: "UTC",
    });
    return `${fmtDay(start)} – ${fmtDay(end)} ${monthName} ${start.getUTCFullYear()}`;
  }
  return `${fmtFull(start)} – ${fmtFull(end)}`;
};

const capitalize = (s) => (s ? s.charAt(0).toUpperCase() + s.slice(1) : "");
